/* assets/armonia-cart-drawer.js
   Upsell del cart drawer:
   1) <armonia-upsell> carica fino a 3 prodotti correlati (Product Recommendations API di
      Shopify, la stessa di Search & Discovery) ai prodotti nel carrello. Se non ne trova,
      resta la lista di fallback già renderizzata da Liquid (collezione scelta nel tema).
   2) "Aggiungi" aggiunge la variante con la Cart API e ridisegna il drawer col metodo di Dawn
      (CartDrawer.renderContents).
   Quantità, rimozione e contatore li gestiscono già cart.js / cart-drawer.js di Dawn. */
(function () {
  'use strict';

  var cache = {}; /* chiave: seed+intent -> Promise<prodotti[]> */

  function fetchRecs(root, seed, intent) {
    var key = seed + ':' + intent;
    if (!cache[key]) {
      var url = root + 'recommendations/products.json?product_id=' + encodeURIComponent(seed) +
        '&limit=10&intent=' + intent;
      cache[key] = fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) { return (d && d.products) || []; })
        .catch(function () { return []; });
    }
    return cache[key];
  }

  /* Collezione di riserva: /collections/<handle>/products.json ha un formato diverso
     (prezzi in stringa sulle varianti, images[] invece di featured_image): lo normalizzo. */
  function fetchCollection(root, handle) {
    var key = 'col:' + handle;
    if (!cache[key]) {
      cache[key] = fetch(root + 'collections/' + encodeURIComponent(handle) + '/products.json?limit=60', {
        headers: { Accept: 'application/json' }
      })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) {
          return ((d && d.products) || []).map(function (p) {
            var vars = p.variants || [];
            var avail = vars.filter(function (v) { return v.available; });
            var prices = (avail.length ? avail : vars).map(function (v) {
              return Math.round(parseFloat(v.price) * 100);
            });
            return {
              id: p.id,
              title: p.title,
              vendor: p.vendor,
              url: root + 'products/' + p.handle,
              price: prices.length ? Math.min.apply(null, prices) : 0,
              available: avail.length > 0,
              featured_image: p.images && p.images[0] ? p.images[0].src : '',
              variants: vars
            };
          });
        })
        .catch(function () { return []; });
    }
    return cache[key];
  }

  /* Ordina per "quanto aiuta a sbloccare la spedizione senza esagerare".
     Finestra ideale: da quanto manca fino a max(2,5x, +15 €). Es.: mancano 10 € → 10–25 €.
     Ordine finale: 1) correlati in finestra  2) riserva in finestra  3) altri che sbloccano
     (dal più economico)  4) quelli sotto soglia (dal più caro, i più vicini). */
  function rank(recs, extra, remaining) {
    var ceil = Math.max(remaining * 2.5, remaining + 1500);
    function asc(a, b) { return a.price - b.price; }
    function inWin(p) { return p.price >= remaining && p.price <= ceil; }
    var a = recs.filter(inWin).sort(asc);
    var b = extra.filter(inWin).sort(asc);
    var c = recs.concat(extra).filter(function (p) { return p.price > ceil; }).sort(asc);
    var d = recs.concat(extra).filter(function (p) { return p.price < remaining; })
      .sort(function (x, y) { return y.price - x.price; });
    return a.concat(b, c, d);
  }

  function imgUrl(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function buildCard(p, strings) {
    var card = el('div', 'armonia-cd__upsell-card');

    var media = el('a', 'armonia-cd__upsell-media');
    media.href = p.url;
    media.tabIndex = -1;
    media.setAttribute('aria-hidden', 'true');
    if (p.featured_image) {
      var img = document.createElement('img');
      img.src = imgUrl(p.featured_image, 160);
      img.alt = '';
      img.loading = 'lazy';
      img.width = 56;
      img.height = 72;
      media.appendChild(img);
    }
    card.appendChild(media);

    var info = el('div', 'armonia-cd__upsell-info');
    if (p.vendor) info.appendChild(el('span', 'armonia-cd__upsell-brand', p.vendor));
    var name = el('a', 'armonia-cd__upsell-name', p.title);
    name.href = p.url;
    info.appendChild(name);
    info.appendChild(el('span', 'armonia-cd__upsell-price', window.Armonia.formatMoney(p.price)));
    card.appendChild(info);

    var avail = (p.variants || []).filter(function (v) { return v.available; });
    if (avail.length === 1) {
      var btn = el('button', 'armonia-cd__upsell-btn', strings.add);
      btn.type = 'button';
      btn.setAttribute('data-armonia-upsell-add', '');
      btn.setAttribute('data-variant-id', avail[0].id);
      btn.setAttribute('aria-label', strings.addLabel.replace('__PRODUCT__', p.title));
      card.appendChild(btn);
    } else {
      var link = el('a', 'armonia-cd__upsell-btn', strings.choose);
      link.href = p.url;
      card.appendChild(link);
    }
    return card;
  }

  class ArmoniaUpsell extends HTMLElement {
    connectedCallback() {
      if (this._started) return;
      this._started = true;

      var d = this.dataset;
      var seeds = (d.seedIds || '').split(',').filter(Boolean);
      if (!seeds.length || !window.Armonia) return;

      var inCart = {};
      (d.cartIds || '').split(',').forEach(function (id) { if (id) inCart[id] = true; });

      var limit = parseInt(d.limit, 10) || 3;
      var remaining = parseInt(d.remaining, 10) || 0;
      var prefer = d.preferUnlock === 'true';
      var strings = { add: d.strAdd, addLabel: d.strAddLabel, choose: d.strChoose };
      var root = d.root || '/';
      var self = this;

      /* Per ogni prodotto nel carrello: prima "complementari", poi "correlati". */
      var jobs = [];
      seeds.forEach(function (seed) {
        jobs.push(fetchRecs(root, seed, 'complementary'));
        jobs.push(fetchRecs(root, seed, 'related'));
      });

      var colJob = d.collection ? fetchCollection(root, d.collection) : Promise.resolve([]);

      Promise.all([Promise.all(jobs), colJob]).then(function (res) {
        var lists = res[0];
        var seen = {};
        function ok(p) {
          if (!p || seen[p.id] || inCart[p.id] || !p.available) return false;
          seen[p.id] = true;
          return true;
        }
        var recs = [];
        /* round-robin tra le liste, così ogni prodotto nel carrello contribuisce */
        for (var i = 0; i < 10; i++) {
          lists.forEach(function (list) { if (ok(list[i])) recs.push(list[i]); });
        }
        var extra = res[1].filter(ok);

        var picks;
        if (prefer && remaining > 0) {
          picks = rank(recs, extra, remaining);
        } else {
          picks = recs.concat(extra);
        }
        if (!picks.length) return; /* resta il fallback di Liquid */

        var list = self.querySelector('[data-armonia-upsell-list]');
        if (!list) return;
        var frag = document.createDocumentFragment();
        picks.slice(0, limit).forEach(function (p) { frag.appendChild(buildCard(p, strings)); });
        list.replaceChildren(frag);
      });
    }
  }
  if (!customElements.get('armonia-upsell')) customElements.define('armonia-upsell', ArmoniaUpsell);

  document.addEventListener('click', function (event) {
    var btn = event.target.closest && event.target.closest('[data-armonia-upsell-add]');
    if (!btn || btn.getAttribute('aria-busy') === 'true') return;
    event.preventDefault();

    var drawer = document.querySelector('cart-drawer');
    var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!drawer || !variantId || !window.routes) return;

    btn.setAttribute('aria-busy', 'true');

    var config = typeof fetchConfig === 'function' ? fetchConfig() : {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
    };
    config.body = JSON.stringify({
      id: variantId,
      quantity: 1,
      sections: 'cart-drawer,cart-icon-bubble',
      sections_url: window.location.pathname
    });

    fetch(window.routes.cart_add_url, config)
      .then(function (response) { return response.json(); })
      .then(function (state) {
        if (state.status || state.errors) {
          throw new Error(state.description || state.message || 'cart error');
        }
        if (window.Armonia && window.Armonia.track) {
          window.Armonia.track('add_to_cart', { source: 'drawer_upsell', variant_id: variantId });
        }
        drawer.renderContents(state);
      })
      .catch(function () {
        btn.removeAttribute('aria-busy');
        var errors = document.getElementById('CartDrawer-CartErrors');
        if (errors && window.cartStrings) errors.textContent = window.cartStrings.error;
      });
  });
  /* Fix intestazione sparita (titolo + X) dopo la prima aggiunta a un carrello vuoto:
     Dawn, quando il carrello era vuoto, tiene la classe "is-empty" su <cart-drawer> e il suo CSS nasconde
     .drawer__header. renderContents sostituisce solo l'interno di #CartDrawer, quindi la classe restava.
     Qui la togliamo ogni volta che il drawer viene ridisegnato con prodotti dentro. */
  function syncEmptyState(drawer) {
    if (!drawer) return;
    var hasItems = !!drawer.querySelector('cart-drawer-items:not(.is-empty) .cart-item');
    drawer.classList.toggle('is-empty', !hasItems);
  }
  customElements.whenDefined('cart-drawer').then(function () {
    var Ctor = customElements.get('cart-drawer');
    if (!Ctor || !Ctor.prototype.renderContents || Ctor.prototype.renderContents.__armonia) return;
    var original = Ctor.prototype.renderContents;
    Ctor.prototype.renderContents = function () {
      var result = original.apply(this, arguments);
      syncEmptyState(this);
      return result;
    };
    Ctor.prototype.renderContents.__armonia = true;
  });
})();
